// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__7wMYz","icon":"style_icon__MWxce","badge":"style_badge__eILBY"};